type MessageObject = {
  [key: string]: () => string;
};

/**
 * Parses a message object obtained from useMessage hook into a sorted list of messages.
 * Assumes that the keys of the messageObject are numeric strings.
 * @param messageArrayObject array object obtained from useMessage hook
 * @returns list of messages sorted by their keys
 */
export const parseMessageList = (messageArrayObject: MessageObject): string[] => {
  const keys = Object.keys(messageArrayObject)
    .map((key) => parseInt(key, 10))
    .filter((num) => !Number.isNaN(num));
  keys.sort((a, b) => a - b);
  return keys.map((key) => messageArrayObject[key]());
};
